const sqlTableMapping = { Lease: "lease_pricing", Lesson: "lesson_pricing", Membership: "membership_pricing" };
export default sqlTableMapping;
